import { createAction } from 'redux-actions';
import {
  AUTH_SIGN_IN_INIT,
  AUTH_SIGN_UP_INIT,
  AUTH_RESET_PASSWORD_INIT,
  AUTH_STRIPE_CONNECT_INIT,
  AUTH_SIGN_OUT,
  AUTH_VERIFY_EMAIL_INIT,
  ADMIN_START_IMPERSONATE,
  ADMIN_END_IMPERSONATE,
  AUTH_IMPERSONATE_INIT,
} from '../actionTypes';

const signInInit = createAction(AUTH_SIGN_IN_INIT);
const signUpInit = createAction(AUTH_SIGN_UP_INIT);
const resetPasswordInit = createAction(AUTH_RESET_PASSWORD_INIT);
const stripeOAuthInit = createAction(AUTH_STRIPE_CONNECT_INIT);
const signOut = createAction(AUTH_SIGN_OUT);
const verifyEmailInit = createAction(AUTH_VERIFY_EMAIL_INIT);
const startImpersonate = createAction(ADMIN_START_IMPERSONATE);
const endImpersonate = createAction(ADMIN_END_IMPERSONATE);
const impersonateInit = createAction(AUTH_IMPERSONATE_INIT);

export {
  verifyEmailInit,
  signInInit,
  signUpInit,
  resetPasswordInit,
  stripeOAuthInit,
  signOut,
  startImpersonate,
  endImpersonate,
  impersonateInit,
};
